import { BRANDS } from "../../../configs";

const fromFieldAdapter = (data, lang, brand) => {
	let defaultGateway;

	if (data?.DefaultGateway) {
		defaultGateway = {
			label: `${data.DefaultGateway?.Name?.trim()} (${data.DefaultGateway?.Code})`,
			value: data.DefaultGateway?.Code,
		};
	} else {
		defaultGateway = {
			label: lang === "fr" ? "Montreal (YUL)" : "Toronto (YYZ)",
			value: lang === "fr" ? "YUL" : "YYZ",
		};
	}

	let defaultGatewayAndList = [];

	if (brand === BRANDS.SOV) {
		const firstLocation = data[0].location;
		let _groupName;

		if (data.every(item => item.location === firstLocation)) {
			_groupName = firstLocation?.split(", ")[0];
		}

		const _data = data.map(item => ({
			label: item?.name,
			value: item?.code,
			location: item.location,
		}));

		defaultGatewayAndList = [defaultGateway, [{ title: _groupName, items: [..._data] }]];
	} else {
		const list = data?.Regions?.reduce((accumulator, region) => {
			const gateways = region?.GatewayGroups?.map(group => ({
				title: group?.Name,
				items: group?.Gateways?.map(gateway => ({
					label: `${gateway?.Name?.trim()} ${gateway?.Code ? `(${gateway?.Code})` : ""}`,
					value: gateway?.Code,
				})),
			}));

			return accumulator.concat(gateways);
		}, []);

		defaultGatewayAndList = [defaultGateway, list];
	}

	return [...defaultGatewayAndList];
};

export default fromFieldAdapter;
